module.exports = __webpack_public_path__ + "static/media/logo_drupal.f7bf3ad8.svg";